export const ACCESSORY_REQUEST = 'ACCESSORY_REQUEST';
export const ACCESSORY_SUCCESS = 'ACCESSORY_SUCCESS';
export const ACCESSORY_ERROR = 'ACCESSORY_ERROR';
